var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPublic(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 20,
    viewBox: "0 0 31 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.1289 9.96484C18.7871 9.96484 16.7998 7.87012 16.7998 5.20605C16.7998 2.58496 18.7979 0.533203 21.1289 0.533203C23.46 0.533203 25.458 2.54199 25.458 5.18457C25.458 7.87012 23.4707 9.96484 21.1289 9.96484ZM8.71094 10.2012C6.66992 10.2012 4.94043 8.375 4.94043 6.06543C4.94043 3.77734 6.68066 1.99414 8.71094 1.99414C10.7412 1.99414 12.4814 3.74512 12.4814 6.04395C12.4814 8.375 10.752 10.2012 8.71094 10.2012ZM2.79199 19.9551C1.3418 19.9551 0.804688 19.3535 0.804688 18.29C0.804688 15.3789 3.90918 11.834 8.71094 11.834C10.6445 11.834 12.1914 12.4033 13.373 13.166C10.9561 15.0566 9.69922 18.3115 10.8379 19.9551H2.79199ZM14.4258 19.9443C12.6641 19.9443 12.0518 19.418 12.0518 18.4297C12.0518 15.6689 15.5537 11.8662 21.1182 11.8662C26.6934 11.8662 30.1953 15.6689 30.1953 18.4297C30.1953 19.418 29.583 19.9443 27.8213 19.9443H14.4258Z",
    fill: "#E5E5EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPublic);
export default __webpack_public_path__ + "static/media/public.c1829be3aed6af2e04863eb4dc31901f.svg";
export { ForwardRef as ReactComponent };